import React, { memo, useCallback } from 'react';

import styled from '@emotion/styled';

import {
  NotFoundDesc1Text,
  NotFoundDesc2Text,
  NotFoundDesc3Text,
} from '@/lib/react-intl/TranslatedTexts';
import { MediumText } from '@/components/text';
import { PrimaryButton } from '@/components/button';
import { InquiryVideo } from '@/pages/inquiry';
import { color } from '@/theme';
import { useNavigate } from 'react-router-dom';
import { CommonDescOne, CommonTitleOne } from '@/components/text/CommonTexts';

const Container = styled.div(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  paddingBottom: '10rem',
}));

const Information = styled.div(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '10rem 0',
  gap: '5rem 0',
  textAlign: 'center',
  whiteSpace: 'break-spaces',
}));

const ButtonWrapper = styled.div(() => ({
  width: '100%',
  padding: '0 1.6rem',
  display: 'flex',
  justifyContent: 'center',
  maxWidth: '32rem',
}));

const NotFound = () => {
  const navigate = useNavigate();

  const goToMain = useCallback(() => {
    navigate('/');
  }, [navigate]);

  return (
    <Container>
      <InquiryVideo />

      <Information>
        <CommonTitleOne>
          <NotFoundDesc1Text />
        </CommonTitleOne>

        <div>
          <CommonDescOne>
            <NotFoundDesc2Text />
          </CommonDescOne>

          <CommonDescOne>
            <NotFoundDesc3Text />
          </CommonDescOne>
        </div>
      </Information>

      <ButtonWrapper>
        <PrimaryButton height="6rem" onClick={goToMain}>
          <MediumText id="lang-go-to-voc-text" color={color.base_white} fontSize={16} />
        </PrimaryButton>
      </ButtonWrapper>
    </Container>
  );
};

export default memo(NotFound);
